// extracted by mini-css-extract-plugin
export default {"rpgGameClanWrapper":"RPGGameClanWrapper_rpgGameClanWrapper__uocdm","rpgGameClanWrapper__bottomWings":"RPGGameClanWrapper_rpgGameClanWrapper__bottomWings__G0jjj"};